import type { PurchasesPackage } from 'react-native-purchases'

export type PurchaseCurrencyCode = 'SEK' | 'EUR'

export interface WebBillingPackagesResult {
  packages: PurchasesPackage[]
  availableOfferingIds: string[]
  currentOfferingIdentifier: string | null
  offeringPackageCounts: Record<string, number>
  availableCurrencies: string[]
  resolvedCurrency: string | null
  usedCurrencyFallback: boolean
}

export const WEB_BILLING_SWEDISH_OFFERING_IDS = ['sek', 'kr']
export const WEB_BILLING_EURO_OFFERING_IDS = ['eur', 'euro']
